import { cloneDeep, get, isArray, set } from 'lodash';
import { getLocalstorageToken } from '../../../../../context/AuthHelper';
import { groupKostenByPosition } from '../../../../../utils/helper';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr } from '../commonFormulas';

// import schemas
import AntragSchema from '../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const executeMobilitaetsPlaeneFormulas = (
	application: any,
	kostenKategories: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string
) => {
	let result: any[] = [];

	let appCopy = cloneDeep(application);
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);
	console.log(' kostenKategoriesGroup ', kostenKategoriesGroup);

	let calcultedProjkJahr = calculateProjektStartJahr(application, vonTag, vonMonat);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);

	let calcultedProjkdauer = calculateProjektDauer(application, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkdauer);

	if (get(appCopy, P.Allgemein_Projektdauerin_Jahren.path) > 0) {
		const allKostenPOsitions_ARR = get(appCopy, P.Foerderantrag_Kostenpositions.path, []);

		for (let i = 0; i < allKostenPOsitions_ARR.length; i++) {
			const eachKosten = allKostenPOsitions_ARR[i];
			const calculatedPositions = transformKostenPositionsData(
				eachKosten,
				get(appCopy, P.Allgemein_Projektstart_Jahr.path),
				get(appCopy, P.Allgemein_Projektdauerin_Jahren.path)
			);
			result.push({
				path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
				value: calculatedPositions,
			});
		}

		// Berechnet die Förderquote auf Jarhen aufgeteilt für Antragsteller und jede Partner
		let calculatedFoerderQuote = calculateFoerderquote(appCopy);
		result.push(...calculatedFoerderQuote);
		for (let ele of calculatedFoerderQuote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Jahrenaufteilung für Ausgaben, Einnahmen, Zuwendung und Förderquote
		let calculatedJahresaufteilung = calculateJahresAufteilung(appCopy);
		result.push(...calculatedJahresaufteilung);
		for (let ele of calculatedJahresaufteilung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Gesamt Förderquote für Antragsteller und jede Partner
		let calculatedGesamtFoerderquote = calculateGesamtFoerderquote(appCopy);
		result.push(...calculatedGesamtFoerderquote);
		for (let ele of calculatedGesamtFoerderquote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
		if (isArray(calculatedGesamtSummeSkizze)) {
			for (let ele of calculatedGesamtSummeSkizze) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		result.push(...calculatedGesamtSummeSkizze);
	}
	return result;
};

function calculateFoerderquote(application: any) {
	let result: any = [];
	const allKostenPositionsARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const AntragstellerId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const VerbundparterIds = get(application, P.Verbundpartner.path, []).map((ele: any) => get(ele, 'Verbundpartner.id'));
	const allKostenpositionVonAntragsteller = allKostenPositionsARR.filter((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === AntragstellerId);
	result.push({
		path: P.Antragstellende_Organisation_Foerderquote.path,
		value: calculateFoerderquoteData(allKostenpositionVonAntragsteller),
	});
	VerbundparterIds.forEach((eachVerbundpartnerId: any) => {
		const VPartnerIndex = get(application, P.Verbundpartner.path, []).findIndex(
			(ele: any) => get(ele, 'Verbundpartner.id') === eachVerbundpartnerId
		);
		const allKostenpositionVonEachVPartner = allKostenPositionsARR.filter(
			(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachVerbundpartnerId
		);
		result.push({
			path: `${P.Verbundpartner.path}.${VPartnerIndex}.Foerderquote`,
			value: calculateFoerderquoteData(allKostenpositionVonEachVPartner),
		});
	});

	return result;
}
function calculateJahresAufteilung(application: any) {
	let result: any = [];
	const allKostenposition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	const calculatedJahreaufteilung = calculateFinancials(allKostenposition);
	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: get(calculatedJahreaufteilung, 'gesamtAusgaben'),
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: get(calculatedJahreaufteilung, 'gesamtZuwendung'),
		},
		{ path: P.Bewilligung_Jahresaufteilung.path, value: get(calculatedJahreaufteilung, 'Jahrenaufteilung') }
	);
	return result;
}
function calculateGesamtFoerderquote(application: any) {
	let result: any = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	// Förderquote für Antragsteller
	const allAusgabenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe'
	);

	const allEinnahmenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme'
	);

	const ausgabenGesamtAntragsteller = allAusgabenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmenGesamtAntragsteller = allEinnahmenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamtAntragsteller = ausgabenGesamtAntragsteller - einnahmenGesamtAntragsteller;
	const foerderQuoteAntragsteller = ausgabenGesamtAntragsteller !== 0 ? (zuwendungGesamtAntragsteller / ausgabenGesamtAntragsteller) * 100 : 0;

	result.push({
		path: P.Orga_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteAntragsteller) ? foerderQuoteAntragsteller.toFixed(2) : 0,
	});

	// Förderquote für einzel Verbundpartner
	const allVerbundPartner = get(application, P.Verbundpartner.path, []);

	allVerbundPartner.forEach((eachPartner: any, i: number) => {
		const eachPartnerId = get(eachPartner, 'Verbundpartner.id');
		if (eachPartnerId) {
			const allAusgabenEachPartner_Arr = allKostenPosition.filter(
				(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachPartnerId && get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe'
			);
			const allEinnahmenEachPartnerr_Arr = allKostenPosition.filter(
				(ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === eachPartnerId && get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme'
			);

			const ausgabenGesamtEachPartner = allAusgabenEachPartner_Arr.reduce((acc: any, ele: any) => {
				return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			}, 0);
			const einnahmenGesamtEachPartner = allEinnahmenEachPartnerr_Arr.reduce((acc: any, ele: any) => {
				return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			}, 0);
			const zuwendungGesamtEachPartner = ausgabenGesamtEachPartner - einnahmenGesamtEachPartner;
			const foerderQuoteEachPartner = ausgabenGesamtEachPartner !== 0 ? (zuwendungGesamtEachPartner / ausgabenGesamtEachPartner) * 100 : 0;

			result.push({
				path: `${P.Verbundpartner.path}.${i}.Foerderquote_Gesamt_403741`,
				value: !isNaN(foerderQuoteEachPartner) ? foerderQuoteEachPartner.toFixed(2) : 0,
			});
		}
	});

	// FörderQuote unabhängig von Antragsteller oder Parter
	// Gesamt aussicht
	const allAusgaben_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe');
	const allEinnahme_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme');

	const ausgabenGesamt = allAusgaben_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmennGesamt = allEinnahme_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamt = ausgabenGesamt - einnahmennGesamt;
	const foerderQuoteGesamt = ausgabenGesamt !== 0 ? (zuwendungGesamt / ausgabenGesamt) * 100 : 0;

	result.push({
		path: P.Bewilligung_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteGesamt) ? foerderQuoteGesamt.toFixed(2) : 0,
	});
	return result;
}

/*
 ***************************************************************************************************************
 * ************************ HELPER FUNCTIONS *******************************************************************
 * *************************************************************************************************************
 */
function transformKostenPositionsData(eachKP: any, projektJahrStart: number, projektDauer: number) {
	const kostenProJahr = get(eachKP, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);

	// Ensure the array length matches projektDauer
	if (kostenProJahr.length < projektDauer) {
		// Add missing years with default values
		for (let i = kostenProJahr.length; i < projektDauer; i++) {
			kostenProJahr.push({
				Zelle_1: projektJahrStart + i,
				Zelle_2: null, // Default value
			});
		}
	} else if (kostenProJahr.length > projektDauer) {
		// Trim the array to match projektDauer
		kostenProJahr.splice(projektDauer);
	}

	// Update Zelle_1 and calculate Zelle_2 sum
	let sumZelle_2 = 0;
	kostenProJahr.forEach((item: any, index: number) => {
		item.Zelle_1 = projektJahrStart + index;
		sumZelle_2 += item.Zelle_2 ? parseFloat(item.Zelle_2) : 0; // Sum with 2 decimal places
	});

	// Update Allgemein_Geplante_Gesamtsumme
	eachKP.attributes.Allgemein_Geplante_Gesamtsumme = sumZelle_2 ? sumZelle_2 : 0;

	// Ensure Zelle_2 values are 2 decimal numbers
	kostenProJahr.forEach((item: any) => {
		item.Zelle_2 = parseFloat(parseFloat(item.Zelle_2 || '0.0').toFixed(2));
	});

	return eachKP;
}
const calculateFoerderquoteData = (data: any[]) => {
	// Extract all unique years from the data
	const years = Array.from(new Set(data.flatMap((item) => item.attributes.Allgemein_Kosten_Pro_Jahr.map((k: any) => k.Zelle_1))));

	// Calculate Foerderquote for each year
	const result = years.map((year) => {
		let sumAusgabe = 0;
		let sumEinnahme = 0;

		data.forEach((item) => {
			get(item, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).forEach((kosten: any) => {
				if (kosten.Zelle_1 === year) {
					const value = parseFloat(kosten.Zelle_2);
					if (!isNaN(value)) {
						if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe') {
							sumAusgabe += value;
						} else if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Einnahme') {
							sumEinnahme += value;
						}
					}
				}
			});
		});

		const foerderquote = sumAusgabe !== 0 ? ((sumAusgabe - sumEinnahme) / sumAusgabe) * 100 : 0;

		return {
			Projektjahr: year,
			Foerderquote_403741: foerderquote.toFixed(2), // Round to two decimal places
		};
	});

	return result;
};
function calculateFinancials(data: any) {
	const result: any = {};

	let gesamtAusgaben = 0;
	let gesamtEinnahme = 0;

	data.forEach((item: any) => {
		const { Allgemein_Kostenposition, Allgemein_Kosten_Pro_Jahr } = item.attributes;

		Allgemein_Kosten_Pro_Jahr.forEach((yearlyCost: any) => {
			const year = yearlyCost.Zelle_1;
			const amount = parseFloat(yearlyCost.Zelle_2) || 0;

			if (!result[year]) {
				result[year] = {
					Projektjahr: year,
					Ausgaben: 0,
					Eigen_45_Und_Drittmittel: 0,
				};
			}

			if (Allgemein_Kostenposition === 'Ausgabe') {
				result[year].Ausgaben += amount;
				gesamtAusgaben += amount;
			} else if (Allgemein_Kostenposition === 'Einnahme') {
				result[year].Eigen_45_Und_Drittmittel += amount;
				gesamtEinnahme += amount;
			}
		});
	});

	const Jahrenaufteilung = Object.values(result).map((item: any) => {
		const { Ausgaben, Eigen_45_Und_Drittmittel } = item;
		const Zuwendung = (Ausgaben || 0) - (Eigen_45_Und_Drittmittel || 0);
		const Foerderquote_403741 = Ausgaben > 0 ? (Zuwendung / Ausgaben) * 100 : 0;

		return {
			...item,
			Ausgaben: Ausgaben.toFixed(2),
			Eigen_45_Und_Drittmittel: Eigen_45_Und_Drittmittel.toFixed(2),
			Zuwendung: Zuwendung.toFixed(2),
			Foerderquote_403741: Foerderquote_403741.toFixed(2),
		};
	});

	const gesamtZuwendung = gesamtAusgaben - gesamtEinnahme;
	const gesamtFoerderQuote = gesamtAusgaben > 0 ? (gesamtZuwendung / gesamtAusgaben) * 100 : 0;

	return {
		gesamtAusgaben: !isNaN(gesamtAusgaben) ? gesamtAusgaben.toFixed(2) : 0,
		gesamtEinnahme: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0,
		gesamtZuwendung: !isNaN(gesamtZuwendung) ? gesamtZuwendung.toFixed(2) : 0,
		gesamtFoerderQuote: !isNaN(gesamtFoerderQuote) ? gesamtFoerderQuote.toFixed(2) : 0,
		Jahrenaufteilung,
	};
}
